module.exports = __webpack_public_path__ + "static/media/S.e885f353.png";